import React, { useState } from "react";
import "./Projects.scss";
import { projectsList } from "../../Data/Data";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const Projects = () => {
  projectsList.sort(function (a, b) {
    return b.id - a.id;
  });

  const [isOpen, setIsOpen] = useState(false);
  const [lightDetails, setLightDetails] = useState("");

  const openLightboxHandler = (img) => {
    setIsOpen(true);
    setLightDetails(img);
  };

  return (
    <section className="projects" id="projects">
      <h6>PORTFOLIO SHOWCASE</h6>
      <h1>MY RECENT WORKS</h1>
      <div className="projects__lists">
        {projectsList.map((pro) => (
          <div className="projects__lists--items" key={pro.id}>
            <h2>
              {pro.name}
              <span>{pro.type && `(${pro.type})`}</span>
            </h2>
            <div
              className="projects__lists--items-img"
              onClick={() => openLightboxHandler(pro)}
            >
              <img
                src={`./images/projects/${pro.image}`}
                alt="project"
                className="bgImg"
              />
              <div className="description">{pro.description}</div>
              <div className="backdrop"></div>
            </div>
            {isOpen && (
              <Lightbox
                mainSrc={`./images/projects/${lightDetails.image}`}
                onCloseRequest={() => setIsOpen(false)}
                imageCaption={lightDetails.description}
              />
            )}
            <div className="projects__lists--items-links">
              <a href={pro.github}>source-code</a>
              <div></div>
              <a href={pro.live}>live-demo</a>
            </div>
            <div className="projects__lists--items-tags">
              {pro.tags.map((t) => (
                <span key={t}>{t}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
